export const APP_VERSION = '3cf0402';
